import axios from 'axios'
import { Toast, Dialog } from 'vant'
// import Cookies from 'js-cookie'
import { store } from '../store'
import {
  // CookieSetting,
  SetGetAuthInfo
} from './auth'
import { router } from '@/router'

const instance = axios.create({
  timeout: 0
})
let isShowLoading = false
let loadingToast = null
// add a request interceptor
instance.interceptors.request.use(function(config) {
  isShowLoading = config.loadingConfig && config.loadingConfig.isShow
  const cookieUser = SetGetAuthInfo.getInfo()
  /* 参数上添加上 cookie */
  if (config.params && !config.params.token) {
    config.params.token = store.state.userInfo.token || cookieUser.token || ''
  }
  if (config.data && !config.data.token) {
    config.data.token = store.state.userInfo.token || cookieUser.token || ''
  }
  if (isShowLoading) {
    loadingToast = Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: config.loadingConfig.text || '加载中...'
    })
  }

  return config
})

// add a response interceptor
instance.interceptors.response.use(
  function(response) {
    if (isShowLoading) {
      loadingToast.clear()
    }
    console.log('%c [ response ]-45', 'font-size:13px; background:pink; color:#bf2c9f;', response)
    console.log(response.headers['content-disposition'])
    if (response.headers['content-disposition']) {
      return {
        data: response.data,
        fileName: response.headers['content-disposition'].split('=')[1]
      }
      // return encodeURI(btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')));
    }
    if (response.data.result === 'SUCCESS') {
      return response.data.content
    }
    if (response.data.code === '200') {
      return response.data.data
    } else {
      if (isShowLoading) {
        loadingToast.clear()
        Toast(response.data.resultMessage)
      }
      if (
        response.data.result === 'INVALID_TOKEN' ||
        response.data.resultMessage == '用户不存在，请重新授权'
      ) {
        Dialog.confirm({
          message: '授权已过期，请您重新获取授权信息！'
        })
          .then(function() {
            SetGetAuthInfo.removeInfo()
            location.href =
              'auth.html?fromPath=' +
              encodeURIComponent(router.currentRoute.fullPath)
          })
          .catch(() => {})
      }
      return Promise.reject(response.data)
      
    }
  },
  function(error) {
    if (isShowLoading) {
      loadingToast.clear()
    }
    return Promise.reject(error)
  }
)
export const request = instance
